// extracted by mini-css-extract-plugin
export default {"section":"Ir-z","sectionTitle":"Jr-z","fieldWrapper":"Kr-z","formField":"Lr-z","disabled":"Mr-z","formLabel":"Nr-z"};